"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.schema = void 0;
var schema = {
  "models": {
    "GroupMeeting": {
      "name": "GroupMeeting",
      "fields": {
        "id": {
          "name": "id",
          "isArray": false,
          "type": "ID",
          "isRequired": true,
          "attributes": []
        },
        "asistenciaGrupo": {
          "name": "asistenciaGrupo",
          "isArray": false,
          "type": {
            "enum": "AsistenciaGrupo"
          },
          "isRequired": false,
          "attributes": []
        },
        "createdAt": {
          "name": "createdAt",
          "isArray": false,
          "type": "AWSDateTime",
          "isRequired": false,
          "attributes": [],
          "isReadOnly": true
        },
        "updatedAt": {
          "name": "updatedAt",
          "isArray": false,
          "type": "AWSDateTime",
          "isRequired": false,
          "attributes": [],
          "isReadOnly": true
        }
      },
      "syncable": true,
      "pluralName": "GroupMeetings",
      "attributes": [{
        "type": "model",
        "properties": {}
      }, {
        "type": "auth",
        "properties": {
          "rules": [{
            "allow": "public",
            "operations": ["create", "update", "delete", "read"]
          }]
        }
      }]
    },
    "ActGroupCredit": {
      "name": "ActGroupCredit",
      "fields": {
        "id": {
          "name": "id",
          "isArray": false,
          "type": "ID",
          "isRequired": true,
          "attributes": []
        },
        "businessKeyAct": {
          "name": "businessKeyAct",
          "isArray": false,
          "type": "String",
          "isRequired": false,
          "attributes": []
        },
        "businessKeyRol": {
          "name": "businessKeyRol",
          "isArray": false,
          "type": "String",
          "isRequired": false,
          "attributes": []
        },
        "idActSchema": {
          "name": "idActSchema",
          "isArray": false,
          "type": "String",
          "isRequired": false,
          "attributes": []
        },
        "businessPrimaryKey": {
          "name": "businessPrimaryKey",
          "isArray": false,
          "type": "String",
          "isRequired": false,
          "attributes": []
        },
        "businessKeySecundary": {
          "name": "businessKeySecundary",
          "isArray": false,
          "type": "String",
          "isRequired": false,
          "attributes": []
        },
        "businnesKeyNamePrimary": {
          "name": "businnesKeyNamePrimary",
          "isArray": false,
          "type": "String",
          "isRequired": false,
          "attributes": []
        },
        "businnesKeyNameSecundary": {
          "name": "businnesKeyNameSecundary",
          "isArray": false,
          "type": "String",
          "isRequired": false,
          "attributes": []
        },
        "nameActSchema": {
          "name": "nameActSchema",
          "isArray": false,
          "type": "String",
          "isRequired": false,
          "attributes": []
        },
        "statusM": {
          "name": "statusM",
          "isArray": false,
          "type": "String",
          "isRequired": false,
          "attributes": []
        },
        "startDate": {
          "name": "startDate",
          "isArray": false,
          "type": "String",
          "isRequired": false,
          "attributes": []
        },
        "lastDate": {
          "name": "lastDate",
          "isArray": false,
          "type": "String",
          "isRequired": false,
          "attributes": []
        },
        "itemPaymentMeet": {
          "name": "itemPaymentMeet",
          "isArray": false,
          "type": "AWSJSON",
          "isRequired": false,
          "attributes": []
        },
        "targetBusinessKey": {
          "name": "targetBusinessKey",
          "isArray": false,
          "type": "String",
          "isRequired": false,
          "attributes": []
        },
        "itemGroupMeet": {
          "name": "itemGroupMeet",
          "isArray": false,
          "type": "AWSJSON",
          "isRequired": false,
          "attributes": []
        },
        "tarjetSecundayKey": {
          "name": "tarjetSecundayKey",
          "isArray": false,
          "type": "Int",
          "isRequired": false,
          "attributes": []
        },
        "createdAt": {
          "name": "createdAt",
          "isArray": false,
          "type": "AWSDateTime",
          "isRequired": false,
          "attributes": [],
          "isReadOnly": true
        },
        "updatedAt": {
          "name": "updatedAt",
          "isArray": false,
          "type": "AWSDateTime",
          "isRequired": false,
          "attributes": [],
          "isReadOnly": true
        }
      },
      "syncable": true,
      "pluralName": "ActGroupCredits",
      "attributes": [{
        "type": "model",
        "properties": {}
      }, {
        "type": "auth",
        "properties": {
          "rules": [{
            "allow": "public",
            "operations": ["create", "update", "delete", "read"]
          }]
        }
      }]
    },
    "PaymentMeet": {
      "name": "PaymentMeet",
      "fields": {
        "id": {
          "name": "id",
          "isArray": false,
          "type": "ID",
          "isRequired": true,
          "attributes": []
        },
        "asistencia": {
          "name": "asistencia",
          "isArray": false,
          "type": {
            "enum": "Asistencia"
          },
          "isRequired": false,
          "attributes": []
        },
        "pagoSemanal": {
          "name": "pagoSemanal",
          "isArray": false,
          "type": {
            "enum": "PagoSemanal"
          },
          "isRequired": false,
          "attributes": []
        },
        "pagoSolidario": {
          "name": "pagoSolidario",
          "isArray": false,
          "type": {
            "enum": "PagoSolidario"
          },
          "isRequired": false,
          "attributes": []
        },
        "negocioMarcha": {
          "name": "negocioMarcha",
          "isArray": false,
          "type": {
            "enum": "NegocioMarcha"
          },
          "isRequired": false,
          "attributes": []
        },
        "createdAt": {
          "name": "createdAt",
          "isArray": false,
          "type": "AWSDateTime",
          "isRequired": false,
          "attributes": [],
          "isReadOnly": true
        },
        "updatedAt": {
          "name": "updatedAt",
          "isArray": false,
          "type": "AWSDateTime",
          "isRequired": false,
          "attributes": [],
          "isReadOnly": true
        }
      },
      "syncable": true,
      "pluralName": "PaymentMeets",
      "attributes": [{
        "type": "model",
        "properties": {}
      }, {
        "type": "auth",
        "properties": {
          "rules": [{
            "allow": "public",
            "operations": ["create", "update", "delete", "read"]
          }]
        }
      }]
    }
  },
  "enums": {
    "NegocioMarcha": {
      "name": "NegocioMarcha",
      "values": ["SI", "NO"]
    },
    "AsistenciaGrupo": {
      "name": "AsistenciaGrupo",
      "values": ["SI", "NO"]
    },
    "Asistencia": {
      "name": "Asistencia",
      "values": ["ATIEMPO", "LLEGOTARDE", "NOASISTIO"]
    },
    "PagoSemanal": {
      "name": "PagoSemanal",
      "values": ["COMPLETO", "INCOMPLETO"]
    },
    "PagoSolidario": {
      "name": "PagoSolidario",
      "values": ["SI", "NO", "PAGONOREQUERIDO"]
    }
  },
  "nonModels": {},
  "codegenVersion": "3.3.6",
  "version": "22a6484892094dac4e2dffe6b3911961"
};
exports.schema = schema;